import { render, staticRenderFns } from "./dashboard-activity-view.vue?vue&type=template&id=3b81ca58&scoped=true&"
import script from "./dashboard-activity-view.vue?vue&type=script&lang=js&"
export * from "./dashboard-activity-view.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-activity-view.vue?vue&type=style&index=0&id=3b81ca58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81ca58",
  null
  
)

export default component.exports